"use strict";
/**
 * Domain Entities for Manulife Insurance Domain.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.Customer = void 0;
const base_1 = require("./base");
class Customer extends base_1.BaseEntity {
    _fullName;
    _age;
    _gender;
    _occupationalClass;
    constructor(id, fullName, age, gender, occupationalClass = 1) {
        super(id);
        if (!fullName || !fullName.trim()) {
            throw new base_1.BaseDomainException('Customer name cannot be empty');
        }
        const validGenders = ['MALE', 'FEMALE', 'M', 'F', 'NAM', 'NỮ'];
        if (!validGenders.includes(gender.toUpperCase())) {
            throw new base_1.BaseDomainException(`Invalid gender: ${gender}`);
        }
        if (occupationalClass < 1 || occupationalClass > 4) {
            throw new base_1.BaseDomainException('Occupational class must be between 1 and 4');
        }
        this._fullName = fullName.trim();
        this._age = age;
        this._gender = gender.toUpperCase();
        this._occupationalClass = occupationalClass;
    }
    get fullName() {
        return this._fullName;
    }
    get age() {
        return this._age;
    }
    get gender() {
        return this._gender;
    }
    get occupationalClass() {
        return this._occupationalClass;
    }
}
exports.Customer = Customer;
